export default [
  'translator',
  'weather',
  'jobs'
]